import {
  StyleSheet,
} from 'react-native';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import {
  primaryFont300,
  primaryFont400,
  primaryFont500,
  primaryFont700,
} from './Common';

export default StyleSheet.create({
  background: {
    backgroundColor: '#333',
    flex: 1,
  },
  inFocus: {
    flex: 1,
    opacity: 1,
  },
  outOfFocus: {
    flex: 1,
    opacity: 0.3,
  },
  menu: {
    flex: 1,
    backgroundColor: '#26272A',
    padding: 0,
    paddingBottom: 40,
  },
  avatarContainerPublisher: {
    padding: 20,
    backgroundColor: '#26272A',
  },
  avatarContainerConsumer: {
    padding: 20,
    backgroundColor: '#26272A',
  },
  avatarTouchable: {
    flex: 1,
    flexDirection: 'row',
    margin: 0,
    padding: 0,
    paddingTop: 50,
    alignContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 6,
    overflow: 'hidden',
    // resizeMode: 'stretch',
    marginRight: 6,
  },
  avatarDefault: {
    width: 48,
    height: 48,
    borderRadius: 6,
    // borderRadius: 24,
    // overflow: 'hidden',
    // resizeMode: 'stretch',
    transform: [
      { scale: 0.5 },
    ],
  },
  name: {
    flex: 1,
    fontSize: 16,
    fontWeight: '700',
    fontFamily: primaryFont700,
    color: 'white',
    paddingLeft: 10,
    paddingBottom: 10,
  },
  email: {
    flex: 1,
    fontSize: 14,
    fontWeight: '300',
    fontFamily: primaryFont300,
    color: 'white',
    paddingLeft: 10,
  },
  switch: {
    // marginBottom: 50,
    margin: 0,
    ...ifIphoneX({
      marginTop: 24,
    }),
    fontSize: 16,
    fontWeight: '700',
    fontFamily: primaryFont700,
    color: '#FE9065',
  },
  itemTop: {
    padding: 0,
    margin: 30,
    marginLeft: 20,
    marginTop: 50,
    marginBottom: 10,
  },
  item: {
    padding: 0,
    margin: 30,
    marginBottom: 15,
    marginLeft: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemLink: {
  },
  itemText: {
    color: 'white',
    fontSize: 20,
    fontWeight: '500',
    fontFamily: primaryFont500,
    lineHeight: 25,
    marginRight: 12,
  },
  item2: {
    padding: 0,
    margin: 0,
    marginBottom: 10,
    marginLeft: 40,
    flexDirection: 'row',
  },
  item2hidden: {
    display: 'none',
  },
  item2Text: {
    color: 'white',
    fontSize: 16,
    fontWeight: '400',
    fontFamily: primaryFont400,
    lineHeight: 32,
  },
});
